<div class="summary-container">
  @if (data().registration.referenceNumber) {

  <div class="reference-box">
    <div class="reference-content">
      <mat-icon class="reference-icon">assignment</mat-icon>
      <span class="reference-label" i18n="@@registration-summary.referenceNumber">Antragsnummer</span>
      <span class="reference-number">{{
        data().registration.referenceNumber
      }}</span>
    </div>
  </div>

  } @if (data().startInfo.school) {
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-icon mat-card-avatar>menu_book</mat-icon>
      <mat-card-title i18n="@@registration-summary.schoolAndCare">Schule & Betreuung</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <dl class="info-list">
        <div class="info-item">
          <dt i18n="@@registration-summary.institution">Einrichtung</dt>
          <dd>{{ data().startInfo.school.schoolName }}</dd>
        </div>

        @if (data().startInfo.module) {
        <div class="info-item">
          <dt i18n="@@registration-summary.careHours">Betreuungszeiten</dt>
          <dd>
            {{
              formatScheduleDays(
                data().startInfo.module.schedule.days || ''
              )
            }}: {{ data().startInfo.module.schedule.startTime }} -
            {{ data().startInfo.module.schedule.endTime }} Uhr
          </dd>
        </div>

        <div class="info-item">
          <dt i18n="@@registration-summary.basicAmount">Grundbetrag</dt>
          <dd>
            {{ data().startInfo.module.fee.amount.toFixed(2) }}
            EUR
          </dd>
        </div>

        @if (data().startInfo.needsCareBeforeSchool !== undefined) {
        <div class="info-item" data-testid="summary-needs-care-before-school">
          <dt i18n="@@registration-summary.needsCareBeforeSchool">
            Betreuung vor Unterrichtsbeginn
          </dt>
          <dd>
            {{ data().startInfo.needsCareBeforeSchool ? yes : no }}
          </dd>
        </div>
        }

        @if (showLunchNotice()) {
        <div class="info-item" data-testid="summary-lunch-notice">
          <dt i18n="@@registration-summary.lunch">Mittagessen</dt>
          <dd i18n="@@registration-summary.lunchNotAwo">
            Läuft nicht über die AWO — Anmeldung, Abmeldung und Abrechnung
            direkt über die Schule bzw. den Caterer
          </dd>
        </div>
        } @else if (data().startInfo.includeLunch !== undefined) {
        <div class="info-item">
          <dt i18n="@@registration-summary.lunch">Mittagessen</dt>
          <dd>
            @if (data().startInfo.includeLunch) { <span i18n="@@registration-summary.yes">Ja</span> (+{{
              lunchFee().toFixed(2)
            }}
            <span i18n="@@registration-summary.eur">EUR</span>) } @else { <span i18n="@@registration-summary.no">Nein</span> }
          </dd>
        </div>
        } @if (data().startInfo.includeLunch !== undefined || showLunchNotice()) {
        <div class="info-item total">
          <dt i18n="@@registration-summary.totalAmount">Gesamtbetrag</dt>
          <dd>
            <strong>{{ calculateTotal().toFixed(2) }} <span i18n="@@registration-summary.eur">EUR</span></strong>
          </dd>
        </div>
        } }
      </dl>
    </mat-card-content>
  </mat-card>
  } @if (data().yearInfo) {
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-icon mat-card-avatar>event</mat-icon>
      <mat-card-title i18n="@@registration-summary.timeframe">Zeitraum</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <dl class="info-list">
        <div class="info-item">
          <dt i18n="@@registration-summary.schoolYear">Schuljahr</dt>
          <dd>
            @if (data().yearInfo.year; as year) {
            {{ year }}/{{ year + 1 }}
            }
          </dd>
        </div>
        @if (data().yearInfo.isCustomDate) {
        <div class="info-item">
          <dt i18n="@@registration-summary.customStartDate">Individueller Starttermin</dt>
          <dd>
            {{
              formatDate(data().yearInfo.startDate)
                | date : 'dd.MM.yyyy'
            }}
          </dd>
        </div>
        }
        @if (contractDeadline) {
        <div class="info-item">
          <dt i18n="@@registration-summary.contractReturnDeadline">
            Vertragsrückgabefrist
          </dt>
          <dd [class.overdue]="isDeadlineOverdue">
            {{ contractDeadline | date: 'dd.MM.yyyy' }}
            @if (isDeadlineOverdue) {
              <mat-icon>warning</mat-icon>
              <span i18n="@@registration-summary.overdue">überfällig</span>
            }
          </dd>
        </div>
        }
      </dl>
    </mat-card-content>
  </mat-card>
  } @if (data()) {
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-icon mat-card-avatar>school</mat-icon>
      <mat-card-title i18n="@@registration-summary.schoolChild">Schulkind</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <dl class="info-list">
        <div class="info-item">
          <dt i18n="@@registration-summary.name">Name</dt>
          <dd>
            {{ data().firstName }}
            {{ data().lastName }}
          </dd>
        </div>
        <div class="info-item">
          <dt i18n="@@registration-summary.birthDate">Geburtsdatum</dt>
          <dd>
            {{ formatDate(data().birthDate) | date : 'dd.MM.yyyy' }}
          </dd>
        </div>

        <div class="info-item">
          <dt i18n="@@registration-summary.gender">Geschlecht</dt>
          <dd>
            @if (data().gender === 'male') {
              <span i18n="@@registration-summary.gender-male">Männlich</span>
            } @else if (data().gender === 'female') {
              <span i18n="@@registration-summary.gender-female">Weiblich</span>
            } @else if (data().gender === 'diverse') {
              <span i18n="@@registration-summary.gender-diverse">Divers</span>
            }
          </dd>
        </div>

        @if (data().healthInfo) {
        <div class="info-item">
          <dt i18n="@@registration-summary.allergies">Allergien</dt>
          <dd>
            {{ data().healthInfo.allergies ? yes : no }}
          </dd>
        </div>
        @if (data().healthInfo.allergies) {
        <div class="info-item description">
          <dd>
            {{ data().healthInfo.allergiesDescription }}
          </dd>
        </div>

        <div class="info-item" data-testid="summary-emergency-medication">
          <dt i18n="@@registration-summary.emergencyMedication">
            Notfallmedikamente
          </dt>
          <dd>
            {{ data().healthInfo.emergencyMedication ? yes : no }}
          </dd>
        </div>

        @if (data().healthInfo.emergencyMedication) {
        <div class="info-item emergency-medication-note">
          <dd>
            <p i18n="@@registration-summary.emergencyMedicationHint">
              Bitte den Notfallplan Anaphylaxie (Unfallkasse Hessen) und die
              Ermächtigungsbescheinigung (Deutscher Allergie- und Asthmabund)
              ausdrucken, ausfüllen, vom Arzt unterschreiben lassen und zeitnah
              in der Einrichtung abgeben.
            </p>
            <a
              href="shared-assets/documents/3-050_UKH_Formular_Notfallplan-Anaphylaxie-Schule.pdf"
              target="_blank"
              rel="noopener"
              i18n="@@student-info-form.emergency-medication-pdf-ukh"
              >Notfallplan Anaphylaxie (Unfallkasse Hessen)</a
            >
            <a
              href="shared-assets/documents/DAAB_Ermaechtigungsbescheinigung.pdf"
              target="_blank"
              rel="noopener"
              i18n="@@student-info-form.emergency-medication-pdf-daab"
              >Ermächtigungsbescheinigung (Deutscher Allergie- und
              Asthmabund)</a
            >
          </dd>
        </div>
        }
        }

        <div class="info-item">
          <dt i18n="@@registration-summary.chronicDiseases">Chronische Krankheiten</dt>
          <dd>
            {{ data().healthInfo.chronicDiseases ? yes : no }}
          </dd>
        </div>
        @if (data().healthInfo.chronicDiseases) {
        <div class="info-item description">
          <dd>
            {{ data().healthInfo.chronicDiseasesDescription }}
          </dd>
        </div>
        }

        <div class="info-item">
          <dt i18n="@@registration-summary.measlesVaccination">Masernimpfung</dt>
          <dd>
            {{ data().healthInfo.measlesVaccination ? '✔' : '❌' }}
          </dd>
        </div>
        @if(!data().healthInfo.measlesVaccination) {
        <div class="info-item">
          <dt i18n="@@registration-summary.vaccinationNoticeAccepted">Impfhinweis akzeptiert</dt>
          <dd>
            {{ data().healthInfo.measlesVaccinationConsent ? '✔' : '❌' }}
          </dd>
        </div>
        } }
      </dl>
    </mat-card-content>
  </mat-card>
  } @if (data().parentInfo) {
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-icon mat-card-avatar>people</mat-icon>
      <mat-card-title i18n="@@registration-summary.parents">Eltern</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <dl class="info-list">
        <div class="info-item">
          <dt i18n="@@registration-summary.singleParenting">Alleinerziehend</dt>
          <dd>
            {{ data().parentInfo.singleParenting ? yes : no }}
          </dd>
        </div>

        @if (data().parentInfo.parent1) {
        <div class="section-title" i18n="@@registration-summary.parent1">Elternteil 1</div>
        <div class="info-item">
          <dt i18n="@@registration-summary.name">Name</dt>
          <dd>
            {{ data().parentInfo.parent1.firstName }}
            {{ data().parentInfo.parent1.lastName }}
          </dd>
        </div>
        <div class="info-item">
          <dt i18n="@@registration-summary.phone">Telefon</dt>
          <dd>
            {{ data().parentInfo.parent1.phoneMobile || '-' }}
          </dd>
        </div>
        @if (data().parentInfo.parent1.address?.formattedAddress) {
        <div class="info-item">
          <dt i18n="@@registration-summary.address">Adresse</dt>
          <dd>
            {{ data().parentInfo.parent1.address?.formattedAddress }}
          </dd>
        </div>
        }
        @if (data().parentInfo.parent1.alternativeAddress) {
        <div class="info-item">
          <dt i18n="@@registration-summary.alternativeAddress">Alternative Adresse</dt>
          <dd>
            {{ data().parentInfo.parent1.alternativeAddress }}
          </dd>
        </div>
        }

        <div class="info-item">
          <dt i18n="@@registration-summary.employed">Berufstätig</dt>
          <dd>
            {{ data().parentInfo.parent1.employed ? yes : no }}
          </dd>
        </div>
        @if (data().parentInfo.parent1.occupation) {
        <div class="info-item">
          <dt i18n="@@registration-summary.occupation">Beruf</dt>
          <dd>{{ data().parentInfo.parent1.occupation }}</dd>
        </div>
        <div class="info-item">
          <dt i18n="@@registration-summary.weeklyWorkHours">Wöchentliche Arbeitszeit</dt>
          <dd>
            {{ data().parentInfo.parent1.weeklyWorkHours }}
          </dd>
        </div>
        }
        <div class="info-item">
          <dt i18n="@@registration-summary.legalGuardian">Erziehungsberechtigt</dt>
          <dd>
            {{ data().parentInfo.parent1.legalGuardian ? yes : no }}
          </dd>
        </div>
        } @if (!data().parentInfo.singleParenting && data().parentInfo.parent2;
        as parent2) {
        <div class="section-title" i18n="@@registration-summary.parent2">Elternteil 2</div>
        <div class="info-item">
          <dt i18n="@@registration-summary.name">Name</dt>
          <dd>
            {{ parent2.firstName }}
            {{ parent2.lastName }}
          </dd>
        </div>
        <div class="info-item">
          <dt i18n="@@registration-summary.phone">Telefon</dt>
          <dd>
            {{ parent2.phoneMobile || '-' }}
          </dd>
        </div>
        <div class="info-item">
          <dt i18n="@@registration-summary.email">E-Mail</dt>
          <dd>
            {{ parent2.email || '-' }}
          </dd>
        </div>
        @if (parent2.alternativeAddress) {
        <div class="info-item">
          <dt i18n="@@registration-summary.alternativeAddress">Alternative Adresse</dt>
          <dd>
            {{ parent2.alternativeAddress }}
          </dd>
        </div>

        }
        <div class="info-item">
          <dt i18n="@@registration-summary.employed">Berufstätig</dt>
          <dd>
            {{ parent2.employed ? yes : no }}
          </dd>
        </div>
        @if (parent2.occupation) {
        <div class="info-item">
          <dt i18n="@@registration-summary.occupation">Beruf</dt>
          <dd>{{ parent2.occupation }}</dd>
        </div>
        <div class="info-item">
          <dt i18n="@@registration-summary.weeklyWorkHours">Wöchentliche Arbeitszeit</dt>
          <dd>
            {{ parent2.weeklyWorkHours }}
          </dd>
        </div>
        }
        <div class="info-item">
          <dt i18n="@@registration-summary.legalGuardian">Erziehungsberechtigt</dt>
          <dd>
            {{ parent2.legalGuardian ? yes : no }}
          </dd>
        </div>
        } @if (data().parentInfo.hasSibling) {
        <div class="section-title" i18n="@@registration-summary.sibling">Geschwisterkind</div>
        <div class="info-item">
          <dt i18n="@@registration-summary.name">Name</dt>
          <dd>{{ data().parentInfo.siblingName }}</dd>
        </div>
        <div class="info-item">
          <dt i18n="@@registration-summary.school">Schule</dt>
          <dd>{{ data().parentInfo.siblingSchoolName }}</dd>
        </div>
        }
      </dl>
    </mat-card-content>
  </mat-card>
  } @if (data().dataPrivacy) {
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-icon mat-card-avatar>gavel</mat-icon>
      <mat-card-title i18n="@@registration-summary.consents">Einwilligungen</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <dl class="info-list">
        <div class="info-item">
          <dt i18n="@@registration-summary.dataPrivacyAccepted">Datenschutzerklärung akzeptiert</dt>
          <dd>
            {{ data().dataPrivacy.hasAccepted ? yes : no }}
          </dd>
        </div>
      </dl>
    </mat-card-content>
  </mat-card>
  }
</div>
